import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';
import { pageContentMap, routeMetaMap } from '@/data/pageContent';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const SITE_BASE = 'https://gbwhetsapp.com';

const hreflangLinks = [
  { rel: 'alternate', hreflang: 'en', href: `${SITE_BASE}/` },
  { rel: 'alternate', hreflang: 'x-default', href: `${SITE_BASE}/` },
];

const views = {
  Download: () => import('@/views/download.vue'),
  Privacy: () => import('@/views/privacy.vue'),
  ContentPage: () => import('@/views/content-page.vue'),
};

function buildMeta(path, fallback) {
  const pageMeta = routeMetaMap[path] || fallback;
  return {
    appname: 'GBWhatsApp',
    title: pageMeta.title,
    keywords: pageMeta.keywords || 'gb whatsapp, gb whatsapp apk, gb whatsapp download',
    description: pageMeta.description,
    link: [{ rel: 'canonical', href: `${SITE_BASE}${path}` }, ...hreflangLinks],
  };
}

function buildRouteName(path) {
  const raw = path.replace(/^\//, '').replace(/\/$/, '').replace(/[^a-z0-9-]+/g, '-');
  return `en-${raw || 'home'}`;
}

const fixedRoutes = [
  {
    path: '/',
    name: 'en-home',
    meta: buildMeta('/', {
      title: 'GB WhatsApp APK Download v18.80 Latest Version 2026',
      description: 'Download GB WhatsApp APK v18.80 with advanced privacy features, custom themes, enhanced messaging tools, install steps, safety notes, and troubleshooting help.',
      keywords: 'GB WhatsApp v18.80, GB WhatsApp APK, GB WhatsApp Download 2026',
    }),
    component: Home,
  },
  {
    path: '/download/',
    name: 'en-download',
    meta: buildMeta('/download/', {
      title: 'Download GB WhatsApp APK Latest Version 2026',
      description: 'Download the latest stable GB WhatsApp APK and follow install, update, backup, and safety best practices.',
      keywords: 'gb whatsapp download, gb whatsapp apk, latest gb whatsapp',
    }),
    component: views.Download,
  },
  {
    path: '/privacy/',
    name: 'en-privacy',
    meta: {
      appname: 'GBWhatsApp',
      title: 'Privacy',
      keywords: 'privacy, gbwhatsapp privacy',
      description: 'Read our privacy policy to understand how we protect your data.',
      link: [{ rel: 'canonical', href: `${SITE_BASE}/privacy/` }, ...hreflangLinks],
    },
    component: views.Privacy,
  },
];

const contentPaths = Object.keys(pageContentMap).filter((path) => !['/download/'].includes(path));

const contentRoutes = contentPaths.map((path) => ({
  path,
  name: buildRouteName(path),
  meta: buildMeta(path, {
    title: pageContentMap[path].title,
    description: pageContentMap[path].subtitle,
    keywords: routeMetaMap[path]?.keywords || 'GB WhatsApp APK, GB WhatsApp download, GB WhatsApp features',
  }),
  component: views.ContentPage,
}));

export const constRoutesPc = [...fixedRoutes, ...contentRoutes];

export default function createRouter() {
  return new VueRouter({
    mode: 'history',
    routes: constRoutesPc,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) return savedPosition;
      if (to.hash) {
        return { selector: to.hash };
      }
      return { x: 0, y: 0 };
    },
  });
}
